/*
 * VULCAN
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/usersMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Users. */
var Users = /** @class */ (function () {
    /**
     * Create a Users.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Users(client) {
        this.client = client;
    }
    Users.prototype.getUsers = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getUsersOperationSpec, callback);
    };
    Users.prototype.createUser = function (request, options, callback) {
        return this.client.sendOperationRequest({
            request: request,
            options: options
        }, createUserOperationSpec, callback);
    };
    Users.prototype.getUser = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, getUserOperationSpec, callback);
    };
    Users.prototype.updateUser = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, updateUserOperationSpec, callback);
    };
    Users.prototype.deleteUser = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, deleteUserOperationSpec, callback);
    };
    Users.prototype.getAuthenticatedUserProfile = function (userId, options, callback) {
        return this.client.sendOperationRequest({
            userId: userId,
            options: options
        }, getAuthenticatedUserProfileOperationSpec, callback);
    };
    Users.prototype.getUserBranches = function (userObjectId, options, callback) {
        return this.client.sendOperationRequest({
            userObjectId: userObjectId,
            options: options
        }, getUserBranchesOperationSpec, callback);
    };
    Users.prototype.getUserSettings = function (userObjectId, options, callback) {
        return this.client.sendOperationRequest({
            userObjectId: userObjectId,
            options: options
        }, getUserSettingsOperationSpec, callback);
    };
    Users.prototype.getUserRoles = function (userObjectId, options, callback) {
        return this.client.sendOperationRequest({
            userObjectId: userObjectId,
            options: options
        }, getUserRolesOperationSpec, callback);
    };
    Users.prototype.getSharedKeyCredential = function (userObjectId, options, callback) {
        return this.client.sendOperationRequest({
            userObjectId: userObjectId,
            options: options
        }, getSharedKeyCredentialOperationSpec, callback);
    };
    Users.prototype.updatePrimarySharedKey = function (userObjectId, request, options, callback) {
        return this.client.sendOperationRequest({
            userObjectId: userObjectId,
            request: request,
            options: options
        }, updatePrimarySharedKeyOperationSpec, callback);
    };
    Users.prototype.updateSecondarySharedKey = function (userObjectId, request, options, callback) {
        return this.client.sendOperationRequest({
            userObjectId: userObjectId,
            request: request,
            options: options
        }, updateSecondarySharedKeyOperationSpec, callback);
    };
    Users.prototype.getAuthenticatedUserPermissions = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getAuthenticatedUserPermissionsOperationSpec, callback);
    };
    Users.prototype.createSharedKeyCredential = function (request, options, callback) {
        return this.client.sendOperationRequest({
            request: request,
            options: options
        }, createSharedKeyCredentialOperationSpec, callback);
    };
    return Users;
}());
export { Users };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getUsersOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "UserResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createUserOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/users",
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateUserRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.UserResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getUserOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: Mappers.UserResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updateUserOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/users/{id}",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateUserRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.UserResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var deleteUserOperationSpec = {
    httpMethod: "DELETE",
    path: "api/v10/users/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getAuthenticatedUserProfileOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/{userId}/profile",
    urlParameters: [
        Parameters.userId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.UserProfileResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getUserBranchesOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/{userObjectId}/branches",
    urlParameters: [
        Parameters.userObjectId
    ],
    queryParameters: [
        Parameters.applicationName1
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "UserBranchInfo"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getUserSettingsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/{userObjectId}/clientSettings",
    urlParameters: [
        Parameters.userObjectId
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "UserSettingsResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getUserRolesOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/{userObjectId}/roles",
    urlParameters: [
        Parameters.userObjectId
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "RoleResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getSharedKeyCredentialOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/{userObjectId}/sharedKey",
    urlParameters: [
        Parameters.userObjectId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.SharedKeyCredentialResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updatePrimarySharedKeyOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/users/{userObjectId}/sharedKey/primary",
    urlParameters: [
        Parameters.userObjectId
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.UpdateSharedKeyCredentialRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.SharedKeyCredentialResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updateSecondarySharedKeyOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/users/{userObjectId}/sharedKey/secondary",
    urlParameters: [
        Parameters.userObjectId
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.UpdateSharedKeyCredentialRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.SharedKeyCredentialResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getAuthenticatedUserPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/users/me/permissions",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PermissionResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createSharedKeyCredentialOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/users/sharedKeys",
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateSharedKeyCredentialRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.SharedKeyCredentialResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=users.js.map